import * as Types from "../../../apollo/graphql.generated";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {};
export type PageThemeFieldsFragment = {
  __typename: "PageTheme";
  background: {
    __typename: "PageThemeBackground";
    type: Types.BackgroundType;
    color: string;
    bottomColor: string | null;
  };
  text: { __typename: "PageThemeText"; color: string; fontFamily: string };
  title: { __typename: "PageThemeTitle"; fontFamily: string };
  corners: { __typename: "PageThemeCorners"; shape: Types.CornersShape };
};

export type PageFieldsFragment = {
  __typename: "Page";
  id: string;
  name: string;
  slug: string;
  status: Types.PageStatus;
  created: string;
  sections: Array<{
    __typename: "PageSection";
    id: string;
    type: Types.SectionType;
    content: {
      __typename: "PageContent";
      editorContent: { __typename: "EditorContent"; state: string } | null;
      mintContent: {
        __typename: "MintContent";
        id: string | null;
        type: Types.MintIdType;
        attributes: {
          __typename: "MintAttributes";
          params: string;
          onChain: boolean;
        };
      } | null;
    };
  }>;
};

export type PageViewQueryVariables = Types.Exact<{
  slug: Types.Scalars["String"];
}>;

export type PageViewQuery = {
  pageView: {
    __typename: "PublicPage";
    isLocked: boolean;
    gate: {
      __typename: "Gate";
      id: string;
      lockedMessage: string | null;
    } | null;
    page: {
      __typename: "Page";
      id: string;
      name: string;
      slug: string;
      status: Types.PageStatus;
      created: string;
      sections: Array<{
        __typename: "PageSection";
        id: string;
        type: Types.SectionType;
        content: {
          __typename: "PageContent";
          editorContent: { __typename: "EditorContent"; state: string } | null;
          mintContent: {
            __typename: "MintContent";
            id: string | null;
            type: Types.MintIdType;
            attributes: {
              __typename: "MintAttributes";
              params: string;
              onChain: boolean;
            };
          } | null;
        };
      }>;
    } | null;
    theme: {
      __typename: "PageTheme";
      background: {
        __typename: "PageThemeBackground";
        type: Types.BackgroundType;
        color: string;
        bottomColor: string | null;
      };
      text: { __typename: "PageThemeText"; color: string; fontFamily: string };
      title: { __typename: "PageThemeTitle"; fontFamily: string };
      corners: { __typename: "PageThemeCorners"; shape: Types.CornersShape };
    } | null;
    creator: {
      __typename: "PublicAccount";
      evmAddresses: Array<string>;
      ensName: string | null;
    } | null;
    unlockGateResult: {
      __typename: "UnlockGateResult";
      passed: boolean;
      type: string | null;
      gateOwnerId: string | null;
      failureReasons: Array<{
        __typename: "FailureReason";
        code: Types.FailureReasonCode;
        reason: string | null;
      }> | null;
      conditionResults: Array<{
        __typename: "ConditionResult";
        type: Types.ConditionType | null;
        selector: string | null;
        required: boolean | null;
        amount: number | null;
        autoBuyButton: Types.BuyMarketplace | null;
        buyButtonUrl: string | null;
        category: string | null;
        passed: boolean;
        userAmount: number | null;
        failureReason: {
          __typename: "FailureReason";
          code: Types.FailureReasonCode;
          reason: string | null;
        } | null;
        data: {
          __typename: "GenericConditionData";
          network: Types.NetworkType | null;
          address: string | null;
          tokenId: string | null;
          allowlistLength: number | null;
          attributes: Array<{
            __typename: "Attribute";
            key: string;
            value: Array<string>;
          }> | null;
        } | null;
      }> | null;
    } | null;
  } | null;
};

export type PublishMutationVariables = Types.Exact<{
  input: Types.PageCreateInput;
}>;

export type PublishMutation = {
  pageCreate: { __typename: "Page"; id: string; slug: string };
};

export type PageUpdateMutationVariables = Types.Exact<{
  input: Types.PageUpdateInput;
  pageId: Types.Scalars["String"];
}>;

export type PageUpdateMutation = {
  pageUpdate: {
    __typename: "Page";
    id: string;
    name: string;
    slug: string;
    gateId: string | null;
  };
};

export type DeleteMutationVariables = Types.Exact<{
  id: Types.Scalars["String"];
}>;

export type DeleteMutation = {
  pageDelete: { __typename: "PageDeleteResult"; deletedCount: number };
};

export type PageQueryVariables = Types.Exact<{
  id: Types.Scalars["String"];
}>;

export type PageQuery = {
  page: {
    __typename: "Page";
    gateId: string | null;
    id: string;
    name: string;
    slug: string;
    status: Types.PageStatus;
    created: string;
    theme: {
      __typename: "PageTheme";
      background: {
        __typename: "PageThemeBackground";
        type: Types.BackgroundType;
        color: string;
        bottomColor: string | null;
      };
      text: { __typename: "PageThemeText"; color: string; fontFamily: string };
      title: { __typename: "PageThemeTitle"; fontFamily: string };
      corners: { __typename: "PageThemeCorners"; shape: Types.CornersShape };
    } | null;
    gate: { __typename: "Gate"; id: string; name: string } | null;
    sections: Array<{
      __typename: "PageSection";
      id: string;
      type: Types.SectionType;
      content: {
        __typename: "PageContent";
        editorContent: { __typename: "EditorContent"; state: string } | null;
        mintContent: {
          __typename: "MintContent";
          id: string | null;
          type: Types.MintIdType;
          attributes: {
            __typename: "MintAttributes";
            params: string;
            onChain: boolean;
          };
        } | null;
      };
    }>;
  };
};

export type PagesQueryVariables = Types.Exact<{ [key: string]: never }>;

export type PagesQuery = {
  pages: Array<{
    __typename: "Page";
    id: string;
    slug: string;
    name: string;
    status: Types.PageStatus;
    created: string;
    gateId: string | null;
    gate: { __typename: "Gate"; id: string; name: string } | null;
  }>;
};

export type GetMintVectorQueryVariables = Types.Exact<{
  vectorId: Types.Scalars["String"];
}>;

export type GetMintVectorQuery = {
  getMintVector: { __typename: "MintVector"; id: string | null };
};

export const PageThemeFieldsFragmentDoc = gql`
  fragment PageThemeFields on PageTheme {
    background {
      type
      color
      bottomColor
    }
    text {
      color
      fontFamily
    }
    title {
      fontFamily
    }
    corners {
      shape
    }
  }
`;
export const PageFieldsFragmentDoc = gql`
  fragment PageFields on Page {
    id
    name
    slug
    sections {
      id
      type
      content {
        editorContent {
          state
        }
        mintContent {
          id
          type
          attributes {
            params
            onChain
          }
        }
      }
    }
    status
    created
  }
`;
export const PageViewDocument = gql`
  query PageView($slug: String!) {
    pageView(slug: $slug) {
      isLocked
      gate {
        id
        lockedMessage
      }
      page {
        ...PageFields
      }
      theme {
        ...PageThemeFields
      }
      creator {
        evmAddresses
        ensName
      }
      unlockGateResult {
        passed
        type
        failureReasons {
          code
          reason
        }
        gateOwnerId
        conditionResults {
          type
          selector
          required
          amount
          failureReason {
            code
            reason
          }
          data {
            network
            address
            tokenId
            attributes {
              key
              value
            }
            allowlistLength
          }
          autoBuyButton
          buyButtonUrl
          category
          passed
          userAmount
        }
      }
    }
  }
  ${PageFieldsFragmentDoc}
  ${PageThemeFieldsFragmentDoc}
`;

/**
 * __usePageViewQuery__
 *
 * To run a query within a React component, call `usePageViewQuery` and pass it any options that fit your needs.
 * When your component renders, `usePageViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePageViewQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function usePageViewQuery(
  baseOptions: Apollo.QueryHookOptions<PageViewQuery, PageViewQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PageViewQuery, PageViewQueryVariables>(
    PageViewDocument,
    options
  );
}
export function usePageViewLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PageViewQuery,
    PageViewQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PageViewQuery, PageViewQueryVariables>(
    PageViewDocument,
    options
  );
}
export type PageViewQueryHookResult = ReturnType<typeof usePageViewQuery>;
export type PageViewLazyQueryHookResult = ReturnType<
  typeof usePageViewLazyQuery
>;
export type PageViewQueryResult = Apollo.QueryResult<
  PageViewQuery,
  PageViewQueryVariables
>;
export const PublishDocument = gql`
  mutation Publish($input: PageCreateInput!) {
    pageCreate(input: $input) {
      id
      slug
    }
  }
`;
export type PublishMutationFn = Apollo.MutationFunction<
  PublishMutation,
  PublishMutationVariables
>;

/**
 * __usePublishMutation__
 *
 * To run a mutation, you first call `usePublishMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishMutation, { data, loading, error }] = usePublishMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePublishMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PublishMutation,
    PublishMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<PublishMutation, PublishMutationVariables>(
    PublishDocument,
    options
  );
}
export type PublishMutationHookResult = ReturnType<typeof usePublishMutation>;
export type PublishMutationResult = Apollo.MutationResult<PublishMutation>;
export type PublishMutationOptions = Apollo.BaseMutationOptions<
  PublishMutation,
  PublishMutationVariables
>;
export const PageUpdateDocument = gql`
  mutation PageUpdate($input: PageUpdateInput!, $pageId: String!) {
    pageUpdate(input: $input, id: $pageId) {
      id
      name
      slug
      gateId
    }
  }
`;
export type PageUpdateMutationFn = Apollo.MutationFunction<
  PageUpdateMutation,
  PageUpdateMutationVariables
>;

/**
 * __usePageUpdateMutation__
 *
 * To run a mutation, you first call `usePageUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePageUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pageUpdateMutation, { data, loading, error }] = usePageUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *      pageId: // value for 'pageId'
 *   },
 * });
 */
export function usePageUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PageUpdateMutation,
    PageUpdateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<PageUpdateMutation, PageUpdateMutationVariables>(
    PageUpdateDocument,
    options
  );
}
export type PageUpdateMutationHookResult = ReturnType<
  typeof usePageUpdateMutation
>;
export type PageUpdateMutationResult =
  Apollo.MutationResult<PageUpdateMutation>;
export type PageUpdateMutationOptions = Apollo.BaseMutationOptions<
  PageUpdateMutation,
  PageUpdateMutationVariables
>;
export const DeleteDocument = gql`
  mutation Delete($id: String!) {
    pageDelete(id: $id) {
      deletedCount
    }
  }
`;
export type DeleteMutationFn = Apollo.MutationFunction<
  DeleteMutation,
  DeleteMutationVariables
>;

/**
 * __useDeleteMutation__
 *
 * To run a mutation, you first call `useDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMutation, { data, loading, error }] = useDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteMutation,
    DeleteMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteMutation, DeleteMutationVariables>(
    DeleteDocument,
    options
  );
}
export type DeleteMutationHookResult = ReturnType<typeof useDeleteMutation>;
export type DeleteMutationResult = Apollo.MutationResult<DeleteMutation>;
export type DeleteMutationOptions = Apollo.BaseMutationOptions<
  DeleteMutation,
  DeleteMutationVariables
>;
export const PageDocument = gql`
  query Page($id: String!) {
    page(id: $id) {
      ...PageFields
      theme {
        ...PageThemeFields
      }
      gateId
      gate {
        id
        name
      }
    }
  }
  ${PageFieldsFragmentDoc}
  ${PageThemeFieldsFragmentDoc}
`;

/**
 * __usePageQuery__
 *
 * To run a query within a React component, call `usePageQuery` and pass it any options that fit your needs.
 * When your component renders, `usePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePageQuery(
  baseOptions: Apollo.QueryHookOptions<PageQuery, PageQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PageQuery, PageQueryVariables>(PageDocument, options);
}
export function usePageLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<PageQuery, PageQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PageQuery, PageQueryVariables>(
    PageDocument,
    options
  );
}
export type PageQueryHookResult = ReturnType<typeof usePageQuery>;
export type PageLazyQueryHookResult = ReturnType<typeof usePageLazyQuery>;
export type PageQueryResult = Apollo.QueryResult<PageQuery, PageQueryVariables>;
export const PagesDocument = gql`
  query Pages {
    pages {
      id
      slug
      name
      status
      created
      gateId
      gate {
        id
        name
      }
    }
  }
`;

/**
 * __usePagesQuery__
 *
 * To run a query within a React component, call `usePagesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePagesQuery({
 *   variables: {
 *   },
 * });
 */
export function usePagesQuery(
  baseOptions?: Apollo.QueryHookOptions<PagesQuery, PagesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PagesQuery, PagesQueryVariables>(
    PagesDocument,
    options
  );
}
export function usePagesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<PagesQuery, PagesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PagesQuery, PagesQueryVariables>(
    PagesDocument,
    options
  );
}
export type PagesQueryHookResult = ReturnType<typeof usePagesQuery>;
export type PagesLazyQueryHookResult = ReturnType<typeof usePagesLazyQuery>;
export type PagesQueryResult = Apollo.QueryResult<
  PagesQuery,
  PagesQueryVariables
>;
export const GetMintVectorDocument = gql`
  query GetMintVector($vectorId: String!) {
    getMintVector(vectorId: $vectorId) {
      id
    }
  }
`;

/**
 * __useGetMintVectorQuery__
 *
 * To run a query within a React component, call `useGetMintVectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMintVectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMintVectorQuery({
 *   variables: {
 *      vectorId: // value for 'vectorId'
 *   },
 * });
 */
export function useGetMintVectorQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetMintVectorQuery,
    GetMintVectorQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetMintVectorQuery, GetMintVectorQueryVariables>(
    GetMintVectorDocument,
    options
  );
}
export function useGetMintVectorLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetMintVectorQuery,
    GetMintVectorQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetMintVectorQuery, GetMintVectorQueryVariables>(
    GetMintVectorDocument,
    options
  );
}
export type GetMintVectorQueryHookResult = ReturnType<
  typeof useGetMintVectorQuery
>;
export type GetMintVectorLazyQueryHookResult = ReturnType<
  typeof useGetMintVectorLazyQuery
>;
export type GetMintVectorQueryResult = Apollo.QueryResult<
  GetMintVectorQuery,
  GetMintVectorQueryVariables
>;
